import { Cartesian3, ScreenSpaceEventType, createGuid, } from "cesium";
import { ConstructionState, Trench } from "../../site/trench/earthbrain-trench";
import { AddPointCommandForTrench } from "./trench-commands";
import { getDefaultTrenchSettings } from "../../settings/earthbrain-site-settings";
import { PositionReference, checkPositionWrtToTileset, } from "../../utilities/local-utilities";
import { CesiumPointSelectorType, } from "../../cesium-utils/point-selector/point-selector";
export class TrenchConstructionHandler {
    _callback;
    _trenchUnderConstruction;
    _viewer;
    _preview;
    _handler;
    _commandManager;
    _cesiumPicker;
    _cesiumPointSelector;
    _finishTrenchConstructionHandler;
    _cesiumViewer;
    _site;
    get trench() {
        return this._trenchUnderConstruction;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._preview = args.preview;
        this._handler = args.handler;
        this._commandManager = args.commandManger;
        this._cesiumPicker = args.cesiumPicker;
        this._cesiumPointSelector =
            args.cesiumPointSelectorFactory.getPointSelector(CesiumPointSelectorType.PriorityBased);
        this._cesiumViewer = cesiumViewer;
    }
    _mouseMoveDebounce = undefined;
    _debounceHandlerForSphereMovement(movement) {
        if (this._mouseMoveDebounce) {
            clearTimeout(this._mouseMoveDebounce);
            this._mouseMoveDebounce = undefined;
        }
        this._mouseMoveDebounce = setTimeout(() => {
            this._functionForPreviewSphereMovement(this._trenchUnderConstruction, movement);
            this._mouseMoveDebounce = undefined;
        }, 100);
    }
    async _functionForPreviewSphereMovement(trench, movement) {
        const cartesian = await this._cesiumPointSelector.getPointOnMousePos(movement.endPosition);
        if (cartesian) {
            this._preview.setSpherePosition(cartesian);
            // add point to the trench id the distance between it and last point is less than 10 KM
            if (this.lastAddedPoint_wgs84 &&
                this.getDistanceFromLastAddedPointInKM(cartesian) < 10) {
                this._preview.setLineVisibility(true);
                this._preview.setLinePosition([
                    this.lastAddedPoint_wgs84.wgs84PointWithAdjustedHeight,
                    cartesian,
                ]);
            }
            else {
                this._preview.setLinePosition([]);
            }
            this._viewer.scene.requestRender();
        }
    }
    _getCallbackCommandForPreviewUpdate() {
        return () => {
            this._preview.setLinePosition([]);
        };
    }
    async addPointOnLeftClick({ position: mousePos, }) {
        const previewPos = await this._cesiumPointSelector.getPointOnMousePos(mousePos);
        if (previewPos) {
            this._site.convertPointsToLocalSpace([previewPos]).then((arr) => {
                const localPos = arr[0];
                const positionRef = checkPositionWrtToTileset(localPos, this._trenchUnderConstruction.associatedTerrain);
                const pickedInfo = positionRef !== PositionReference.OUTSIDE
                    ? this._cesiumPicker.getPickablePickedInfo(mousePos)
                    : undefined;
                // Do not process further
                if (positionRef === PositionReference.OUTSIDE) {
                    this.raiseEventInvalidCtrlPtForTrench(this._trenchUnderConstruction.id);
                    return;
                }
                if (!localPos) {
                    console.error("Cound not find the Point");
                    return;
                }
                if (this.getDistanceFromLastAddedPointInKM(previewPos) < 10) {
                    this._commandManager.action(new AddPointCommandForTrench(this._trenchUnderConstruction, {
                        position: previewPos,
                        info: pickedInfo,
                        localPosition: localPos,
                    }, this._getCallbackCommandForPreviewUpdate()), this._cesiumViewer);
                    this._preview.setLineVisibility(true);
                    this._preview.setLinePosition([]);
                }
                this._callback.onProgress &&
                    this._callback.onProgress(this._trenchUnderConstruction.id, 0);
            });
        }
    }
    //   private _onMouseRightDown() {
    //     this._isMouseRightClicked = true;
    //     this._handler.setInputAction(this._onMouseRightUp.bind(this), Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    //   private _onMouseRightUp() {
    //     this._isMouseRightClicked = false;
    //     this._handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    clearCommandManager() {
        this._commandManager.clear();
    }
    start(callback, associatedTerrain, associatedRubbingDestination) {
        this._callback = callback;
        this._trenchUnderConstruction = new Trench(this._viewer, createGuid(), getDefaultTrenchSettings(), associatedTerrain, associatedRubbingDestination);
        this._trenchUnderConstruction.constructionState =
            ConstructionState.UNDER_CONSTRUCTION;
        this._preview.setSphereVisibility(true);
        this._handler.setInputAction(this._debounceHandlerForSphereMovement.bind(this), ScreenSpaceEventType.MOUSE_MOVE);
        this._handler.setInputAction(this.addPointOnLeftClick.bind(this), ScreenSpaceEventType.LEFT_CLICK);
        this._finishTrenchConstructionHandler =
            this._finishTrenchConstruction.bind(this);
        document.addEventListener("keydown", this._finishTrenchConstructionHandler);
    }
    _finishTrenchConstruction(event) {
        switch (event.key) {
            case "Esc":
            case "Escape":
                this.cancel();
                break;
            case "Enter":
                this.finish();
                break;
            default:
        }
    }
    finish() {
        this.clearCommandManager();
        if (this._trenchUnderConstruction.controlPointLength > 1) {
            // First Point
            this._trenchUnderConstruction.constructionState = ConstructionState.READY;
            this._site.addTrench(this._trenchUnderConstruction);
            this._preview.setLineVisibility(false);
            this._preview.setSphereVisibility(false);
            // this._viewer.scene.requestRender();
            this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this._finishTrenchConstructionHandler &&
                document.removeEventListener("keydown", this._finishTrenchConstructionHandler);
            this._callback.onFinish &&
                this._callback.onFinish(this._trenchUnderConstruction.id);
        }
        else {
            console.warn("Trench needs at least 2 points.");
            this.cancel();
        }
    }
    cancel() {
        if (this._trenchUnderConstruction) {
            this._trenchUnderConstruction.dispose();
        }
        this._trenchUnderConstruction = undefined;
        this._preview.setSphereVisibility(false);
        this._preview.setLineVisibility(false);
        // this._viewer.scene.requestRender();
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._finishTrenchConstructionHandler &&
            document.removeEventListener("keydown", this._finishTrenchConstructionHandler);
        this._callback?.onCancel && this._callback.onCancel();
        this._viewer.scene.requestRender();
    }
    raiseEventInvalidCtrlPtForTrench(trenchId) {
        const event = new CustomEvent("invalidControlPointForTrench", {
            detail: { trenchId, type: 7 },
        });
        window.dispatchEvent(event);
        this._callback.onError && this._callback.onError();
    }
    //private
    get lastAddedPoint_wgs84() {
        return this._trenchUnderConstruction.cesiumRenderableAlignment.ipLinePoints[this._trenchUnderConstruction.cesiumRenderableAlignment.ipLinePoints
            .length - 1];
    }
    getDistanceFromLastAddedPointInKM(point) {
        if (!this.lastAddedPoint_wgs84) {
            return 0;
        }
        const distance = Cartesian3.distance(point, this.lastAddedPoint_wgs84.wgs84Point);
        return distance * 0.001; // convert to km
    }
}
//# sourceMappingURL=trench-construction-handler.js.map